
import AdvancedLoader from './advancedloader'

export default AdvancedLoader;